module.exports = __webpack_public_path__ + "media/icons/opony-zimowe-green@3x-e39e2d54.svg";